
import Button from '@material-ui/core/Button'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Fab from '@material-ui/core/Fab'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CloseIcon from '@material-ui/icons/Close'
import ForumIcon from '@material-ui/icons/ForumOutlined'
import moment from 'moment'
import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import {
  createCase,
  getAccountNumber,
  getEnrollMemberInfoById,
  getMemberPlanData,
  getNeoTransaction,
  getPaymentCardDetails,
  getPaymentDetails,
  getPaymentType,
  getRecurringDateData,
  getSourceCode,
  getTransactionData,
  storeTransaction
} from '../../ApiCall'
import CommonLoader from '../../CommonLoader'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CommonFooter from '../CommonFooter'
import Header from '../Header'
import CommonDropDwn from './CommonDropDwn'
import CustomeCss from './paymentmode.css.js'
import Sample from './sampleTextField'
import customStyle from './stylesheet_UHS'
import './Transaction.css'
import TransactionDataTable from './TransactionDataTable'
import axios from 'axios'
import Suggestions from './Suggestions'
import { Tooltip } from '@material-ui/core'
var convert = require("xml-js");

const CrudButton = withStyles(customStyle.crudBtn)(Fab)

const AntTabs = withStyles(customStyle.tabs)(Tabs)

const AntTab = withStyles(theme => customStyle.tab)(props => <Tab disableRipple {...props} />)

const NextButton = withStyles(customStyle.PayButton)(Button)

const PurpleRadio = withStyles(customStyle.radioBtn)(props => <Radio color="default" {...props} />)

const getPaymentPopUp = () => {
  return window.location.href.includes('payment') ? true : false
}
const getDraftDayPopUp = () => {
  return window.location.href.includes('billing') ? true : false
}

const currentYear = new Date().getFullYear();
const next10Years = Array.from({ length: 10 }, (_, index) => currentYear + index);

export default class Transaction extends Component {
  constructor(props) {
    super(props)
    this.state = {
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      disabled: true,
      tableData: [],
      open: false,
      activeTab: 0,
      accountTypes: ['CHECKING', 'SAVINGS'],
      bankName: '',
      accountName: localStorage.getItem('guardianName') || localStorage.getItem('subscriberName'),
      accountType: '',
      routingNo: '',
      accountNumber: '',
      cardNumber: '',
      holderName: localStorage.getItem('guardianName') || localStorage.getItem('subscriberName'),
      expiryMonth: '',
      expiryYear: '',
      monthlyDebitDay: '',
      payType: '',
      cvv: '',
      selectedValue: '',
      years: next10Years,
      sourceCode: localStorage.getItem('sourceid'),
      empid: null,
      disabled2: true,
      errorModal: false,
      MsgModal: '',
      accountNo: null,
      MsgModalerror: '',
      loader: true,
      notfoundmsg: '',
      errCodeCC: false,
      errCodeACH: false,
      MsgModalerrorFooterACH: '',
      MsgModalerrorFooterCC: '',
      reqFlag: true,

      draftDayModal: false,
      nextRecurringDate: '',
      draftDaySelected: '',
      memberPlanInfo: '',
      effectivePaymentDate: '',
      firstPaymentDate: '',
      firstPaymentAmount: '',
      todayDate: '',
      initialApplicationFee: '',
      STATE_PARAM: JSON.parse(sessionStorage.getItem('STATE_PARAM')),
      subsequentPaymentDate: '',
      beforeEffectiveDate: null,
      effectiveDateModal: false,
      beforeEffectiveDateFlag: false,
      paymentData: [],
      paymentDatamodel:{},
      paymentType: '',
      currentMonthDays: [],
      selectedBillingDay: '',
      currentMonthName: ''
    }
  }

  billingPopUp = async () => {
    await this.getTransactionData1(localStorage.getItem('sourceid'))
    await this.getTransactionData()
    await this.getAccountNumber()
    await this.getSourceCodeFun()
    await this.getPaymentData()
    await this.openDraftDayModal()
    await this.getPayType()
  }

  componentDidMount() {
    this.setState({ loader: true })

    if (getDraftDayPopUp()) {
      this.billingPopUp()
    }
    if (getPaymentPopUp()) {
      this.handleClickOpen()
    }
    if (localStorage.getItem('SOURCE') === 'NEO') {
      this.getNeoTransactionData()
    } else {
      this.getTransactionData()
      this.getTransactionData1(localStorage.getItem('sourceid'))
      this.getAccountNumber()
      this.getSourceCodeFun()
      this.getPaymentData()
      this.getPayType(localStorage.getItem('sourceid'))
      this.getSubID();
    }
  }

  getSubID = () =>{
    axios.get(process.env.REACT_APP_BASE_URL + 'v3.0/enrollment/getEnrollMemberInfoById/' + this.state.sourceCode).then(res => {
      if (res.data.response !== null) {
        this.setState({subId: res.data.response.subId}, () => this.getAddress());
      }
    })
  }

  getAddress = () => {
    fetch(
      process.env.REACT_APP_BASE_URL + "v3.0/setupfamily/getMemberInfo/" + this.state.subId
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState(
          {
            loader: false,
            isBillStreetSelected: response.response.mailAddress1 ? true : false,
            userBillingAddress: {
                zip: response.response.mailPostalCode,
                city: response.response.mailCity,
                state: response.response.mailState,
                country: response.response.mailCountry,
                street: response.response.mailAddress1,
                addrs: response.response.address2 || ""
              },
            loader: false,
          },
          () => this.validateForm()
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  submitAddress = () => {
    this.state.isBillAddrValid = true;
    this.setState({
      isBillAddrValid: true,
      addressModal: false,
      isBillStreetSelected: true,
      isFirstTime: true,
      loader: true,
    });
    let billObj = {
      "subId": this.state.subId,
      "mailAddress1": this.state.userBillingAddress.street,
      "mailCountry": this.state.userBillingAddress.country,
      "mailCity": this.state.userBillingAddress.city,
      "mailState": this.state.userBillingAddress.state,
      "mailPostalCode": this.state.userBillingAddress.zip,
      "address2": this.state.userBillingAddress.addrs
    }

    let obj = new Object();
    obj.subId = this.state.subId;
    obj = { ...billObj };
    console.log("valid add");
    axios
      .post(process.env.REACT_APP_BASE_URL + "v3.0/setupfamily/addMemberAddress", obj)
      .then((response) => {
        if (response.data.code === 200) {
          this.setState({
            addressModal: false,
            isBillAddrValid: true,
            // storedTranModal: true,
            waitingRes: "true",
          });
          localStorage.removeItem("PAYMENT_ERROR");

          let paymentType = "";
          if (this.state.activeTab === 0) {
            paymentType = "ACH";
          } else {
            paymentType = "CC";
          }

          const data = {
            "accountName": this.state.accountName,
            "accountNumber": this.state.accountNumber,
            "accountType": this.state.accountType,
            "bankName": this.state.bankName,
            "cardNumber": this.state.cardNumber,
            "cvv": this.state.cvv,
            "expiryMonth": this.state.expiryMonth ? moment().month(this.state.expiryMonth).format("M") : "",
            "expiryYear": this.state.expiryYear,
            "holderName": this.state.holderName,
            "paymentType": paymentType,
            "paymentMode": paymentType,
            "routingNo": this.state.routingNo,
            "source": this.state.sourceCode,
            "subId": this.state.subId
          }
          axios.post(process.env.REACT_APP_BASE_URL + 'v6/transaction/storeTransaction', data).then((response) => {
            if (response.data.code == 200) {
              this.setState({ errorModal: true, open: false, loader: false, MsgModal: 'The payment details have been updated successfully.' })
            }else if (response.data.code == 202) {
              let raw = String(response?.data?.response || '')
              let msg = raw

              if (raw.startsWith('500')) {
                let match = raw.match(/"message"\s*:\s*"([^"]+)"/)
                if (match) {
                  msg = match[1].split(' REFID')[0].trim()
                }
              } else {
                msg = raw.replace('{', '').replace('}', '').replace(/"/g, ' ')
              }

              this.setState({ errorModal: true, MsgModal: msg, loader: false, errCodeACH: true })

            }else if (response.data.code == 204) {
                let x = String("Source is not registered");
                this.setState({ errorModal: true, MsgModal: x, loader: false, errCodeACH: true }) 
            }else{
              let x = String(response.data.response);
              this.setState({ errorModal: true, MsgModal: x, loader: false, errCodeACH: true }) 
            }
          })
        }
      });
    this.setState({ disabled: false })
  };

  hideModal = (event) => {
    this.setState(
      {
        disabled: false,
        addressModal: false,
        isBillAddrDiff: false,
        isBillAddrValid: false,
        isFirstTime: true,
        suggestions: {result: []}
      },
      () => {
        this.validateForm();
      }
    );
  };

  isDisableSubmit = () => {
    const restBillingAddress = { ...this.state.userBillingAddress };
    delete restBillingAddress.addrs;
    this.setState({
      isBillAddrValid:
      // !this.state.isBillStreetSelected ||
        Object.values(restBillingAddress).some(
          (x) => x === null || x === ""
        )
    })
  };

  jumpToPayment() {
    let url = window.location.href
    if (url.split('Transaction?').length > 1) {
      let queryString = url.split('Transaction?')[1]
      let queryParams = new URLSearchParams(queryString)
      let change_payment = decodeURI(queryParams.get('change_payment'))
      if (change_payment === 'true') {
        this.handleClickOpen()
      }
      this.props.history.replace('/Transaction')
    }
  }
  getNeoTransactionData = () => {
    getNeoTransaction().then(res => {
      if (res.data.totalrecords > 0) {
        this.setState({ tableData: res.data.pageList, loader: false })
      } else {
        this.setState({ notfoundmsg: 'My Transactions Data Not Available', loader: false })
      }
      this.jumpToPayment()
    })
  }

  getSourceCodeFun = () => {
    getSourceCode()
      .then(res => {
        if (res && res.data) {
          this.setState(
            {
              sourceCode: res.data.memberIdSource,
              empid: res.data.empId,
              accountTypes: ['CHECKING', 'SAVINGS'],
              loader: false
            },
            () => {
              this.getEnrollMember(res.data.memberIdSource)
              this.getPayType(res.data.memberIdSource)
            }
          )
        } else {
          this.setState(
            {
              sourceCode: res.data.memberIdSource,
              empid: res.data.empId,
              accountTypes: ['CHECKING', 'SAVINGS'],
              loader: false
            },
            () => {
              this.getEnrollMember(res.data.memberIdSource)
              this.getPayType(res.data.memberIdSource)
            }
          )
        }
      })
      .catch()
  }

  getTransactionData = () => {
    getTransactionData().then(res => {
      if (res.data.response.length > 0) {
        this.setState({ tableData: res.data.response, loader: false }, () => {
          let type = this.state.tableData.map(val => {
            return val.type
          })

          this.setState({ payType: type })
        })
      } else {
        this.setState({ notfoundmsg: 'My Transactions Data Not Available', loader: false })
      }
    })
  }

  getTransactionData1 = (sourceid) => {
      getPaymentCardDetails(sourceid)
        .then(res => {
          if (res && res.data) {
            this.setState(
              {
                paymentData: res.data.data
              }
            )
          }
        })
        .catch();
    }

  getAccountNumber = () => {
    getAccountNumber().then(res => {
      if (res.data.code === 200) {
        this.setState({ accountNo: res.data.response.replaceAll('*', 'X'), loader: false })
      } else if (res.data.code === 202) {
        let x = JSON.parse(res.data.response).error_message
        let errMsg = ''
        if (x.includes('-')) {
          let cds = x.split(' - ')
          errMsg = cds[1]
        } else {
          errMsg = x
        }
        if (this.state.activeTab === 0) {
          this.setState({
            accountNo: '',
            MsgModalerrorFooterACH: errMsg
          })
        } else {
          this.setState({
            accountNo: '',
            MsgModalerrorFooterCC: errMsg
          })
        }
      } else {
        this.setState({ accountNo: '' })
      }
      this.jumpToPayment()
    })
  }

  handleClose = () => {
    this.setState(
      {
        open: false,
        bankName: '',
        accountName: this.state.accountName,
        accountNumber: '',
        accountType: '',
        routingNo: '',

        cardNumber: '',
        holderName: this.state.holderName,
        expiryMonth: '',
        expiryYear: '',
        cvv: '',
        payType: '',
        MsgModalerror: '',
        errCodeACH: false,
        errCodeCC: false,
        MsgModalerrorFooterACH: '',
        MsgModalerrorFooterCC: ''
      },
      () => this.validateForm()
    )
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  formatAutocompleteSuggestion(suggestion) {
        const addressText = suggestion.address_text ? `${suggestion.address_text} ` : "";
        const street = suggestion.street_line ? `${suggestion.street_line} ` : "";
        const secondary = suggestion.secondary ? `${suggestion.secondary} ` : "";
        const entries = suggestion.entries !== 0 ? `(${suggestion.entries}) ` : "";
        const city = suggestion.city ? `${suggestion.city} ` : "";
        const state = suggestion.state ? `${suggestion.state}, ` : "";
        const zip = suggestion.zipcode ? `${suggestion.zipcode}` : "";
        const addrs = suggestion.addrs ? `${suggestion.addrs}` : "";

        return addressText + street + secondary + entries + city + state + zip + addrs;
    }

    queryAutocompleteForSuggestions(searchValue, addressId, hasSecondaries) {
        let zipCode = "";
        let state = "";
        if (this.state.isMailingStreet) {
            if (this.state.userAddress.postalCode) zipCode = this.state.userAddress.postalCode;
            else state = this.state.userAddress.state;
        } else if (this.state.userBillingAddress) {
            if (this.state.userBillingAddress.zip) zipCode = this.state.userBillingAddress.zip;
            else state = this.state.userBillingAddress.state;
        }

        axios.get(`${process.env.REACT_APP_SMARTY_API}/lookup?auth-id=${process.env.REACT_APP_SMARTY_AUTH_ID}&auth-token=${process.env.REACT_APP_SMARTY_AUTH_TOKEN}&include_only_zip_codes=${zipCode}&include_only_states=${state}&search=${searchValue}&address_id=${addressId}&selected=${hasSecondaries ? searchValue : ""}`)
            .then(results => {
                if (results.data.errors) {
                    if (this.state.isMailingStreet) this.setState({ isMailStreetSelected: true }, () => this.isDisableSubmit())
                        else this.setState({ isBillStreetSelected: true }, () => this.isDisableSubmit())
                }
                else this.setState({ suggestions: results.data.suggestions });
            })
            .catch(err => {
                if (this.state.isMailingStreet) this.setState({ isMailStreetSelected: true }, () => this.isDisableSubmit())
                    else this.setState({ isBillStreetSelected: true }, () => this.isDisableSubmit())
            });
    }

    selectSuggestion(suggestion) {
        if (suggestion.entries > 1) {
            this.queryAutocompleteForSuggestions(this.formatAutocompleteSuggestion(suggestion), "", true);
            // this.queryAutocompleteForSuggestions(this.formatAutocompleteSuggestion(suggestion), suggestion.addressId, true);
        } else {
            this.useAutoCompleteSuggestion(suggestion)
                .then(() => {
                    if (this.state.shouldValidate) this.validateAddress();
                });
        }
    }

    useAutoCompleteSuggestion(data) {
        return new Promise(resolve => {
            if (this.state.isMailingStreet) {
                this.state.isMailStreetSelected = true
                this.setState({
                    userAddress: {
                        postalCode: data.zipcode,
                        city: data.city.toUpperCase(),
                        state: data.state.toUpperCase(),
                        country: "US",
                        street: data.street_line,
                        addrs: this.state.userAddress.addrs
                    },
                    suggestions: {},
                    makeCityValid: true,
                    makeStateValid: true
                }, () => {
                    this.isDisableSubmit()
                    return resolve
                });
            } else {
                this.state.isBillStreetSelected = true
                this.setState({
                    userBillingAddress: {
                        zip: data.zipcode,
                        city: data.city.toUpperCase(),
                        state: data.state.toUpperCase(),
                        country: "US",
                        street: data.street_line,
                        addrs: this.state.userBillingAddress.addrs
                    },
                    suggestions: {},
                    makeBZipValid: true,
                    makeBCityValid: true,
                    makeBStateValid: true,
                    makeBCountryValid: true,
                }, () => {
                    this.isDisableSubmit()
                    return resolve
                });
            }
            this.isDisableSubmit();
        });
    }

    handlePostalCode = (zipcode, parent, fromDrop) => {
    this.setState({
      loader: true
    });
    // let url = `https://secure.shippingapis.com/ShippingAPI.dll?API=CityStateLookup&XML=<CityStateLookupRequest USERID="935USTGL7449"><ZipCode ID="0"><Zip5>${zipcode}</Zip5></ZipCode></CityStateLookupRequest>`;
     let url = `${process.env.REACT_APP_NEW_BASE_URL_AGENT_DETAIL}agency/api/zipcode/lookup?zipcode=${zipcode}`
    axios
      .get(url)
      .then((response) => {
       var result2 = response.data;
        if (!result2.stateAbbreviation) {
          var evt = new CustomEvent("zip", {
            detail: {
              zipcode: zipcode,
              flag: true,
              errMsg: "Enter valid zip code",
            },
          });
          window.dispatchEvent(evt);
          this.state.userBillingAddress.street = "";
          this.state.userBillingAddress.city = "";
          this.state.userBillingAddress.state = "";
          this.state.userBillingAddress.zip = "";
          this.state.userBillingAddress.country = "US";
          this.state.userBillingAddress.addrs = "";
          this.setState(
            {
              refresh: true,
              loader: false,
            },
            () => this.isDisableSubmit()
          );
        } else {
                if(!fromDrop) this.state.userBillingAddress.street = "";
                else this.state.isValidBillingZip = true
                this.state.userBillingAddress.city = result2.city;
                this.state.userBillingAddress.state = result2.stateAbbreviation;
                this.state.userBillingAddress.zip = result2.zipcode;
                this.state.userBillingAddress.country = "US";
                this.setState(
                  {
                    refresh: true,
                    loader: false,
                  },
                  () => this.isDisableSubmit()
                );
        }
      })
      .catch((error) => {
        let evt = new CustomEvent("zip", {
          detail: {
            zipcode: zipcode,
            flag: true,
            errMsg: "Enter valid zip code",
          },
        });
        window.dispatchEvent(evt);
        this.state.userBillingAddress.city = "";
        this.state.userBillingAddress.state = "";
        this.state.userBillingAddress.zip = "";
        this.state.userBillingAddress.country = "US";
        this.state.userBillingAddress.addrs = "";
        this.setState(
          {
            refresh: true,
            loader: false,
            msgModal: true,
          },
          () => {
            this.changeTextFieldHandler(zipcode, false, parent);
          }
        );
      });
  };

  changeTextFieldHandler = (val, isValid, parentObj) => {
    if (parentObj.flag == "BillAddr") {
      switch (parentObj.label) {
        case "BillAddr-Zip":
          if (isValid) {
            this.state.userBillingAddress.zip = val;
            this.setState({ makeBZipValid: true, loaderShow: true })
            this.handlePostalCode(val, parentObj);
          } else {
            this.setState({ makeBZipValid: false })
            this.state.userBillingAddress.zip = "";
          }
          break;
        case "BillAddr-Street":
          this.state.userBillingAddress.street = isValid ? val : "";
          this.state.isMailingStreet = false
          this.state.isBillStreetSelected = false
          // this.queryAutocompleteForSuggestions(val)
          break;
        case "BillAddr-city":
          if (isValid) {
            this.state.userBillingAddress.city = val.toUpperCase();
            this.setState({ makeBCityValid: true })
          } else {
            this.state.userBillingAddress.city = ""
            this.setState({ makeBCityValid: false })
          }
          break;
        case "BillAddr-state":
          if (isValid) {
            this.state.userBillingAddress.state = val;
            this.setState({ makeBStateValid: true })
          } else {
            this.state.userBillingAddress.state = ""
            this.setState({ makeBStateValid: false })
          }
          break;
        case "BillAddr-country":
          if (isValid) {
            this.state.userBillingAddress.country = val;
            this.setState({ makeBCountryValid: true })
          } else {
            this.state.userBillingAddress.country = ""
            this.setState({ makeBCountryValid: false })
          }
          break;
        case "BillAddr-Address":
          this.state.userBillingAddress.addrs = val;
          break;
        default:
          break;
      }
      this.isDisableSubmit();
    }
    if (parentObj.label === 'bank_name') {
      if (isValid) {
        this.state.bankName = val
      } else {
        this.state.bankName = ''
      }
    } else if (parentObj.label === 'Account_Name') {
      if (isValid) {
        this.state.accountName = val
      } else {
        this.state.accountName = ''
      }
    } else if (parentObj.label === 'Routing_Number') {
      if (isValid) {
        this.state.routingNo = val
        this.state.errCodeACH = false
      } else {
        this.state.routingNo = ''
      }
    } else if (parentObj.label === 'Account_Number') {
      if (isValid) {
        this.state.accountNumber = val
      } else {
        this.state.accountNumber = ''
      }
    } else if (parentObj.label === 'Account_Type') {
      if (isValid) {
        this.state.accountType = val
      } else {
        this.state.accountType = ''
      }
    } else if (parentObj.label === 'Card_Number') {
      if (isValid) {
        this.state.cardNumber = val
        this.state.MsgModalerror = ''
        this.state.errCodeCC = ''
      } else {
        this.state.cardNumber = ''
      }
    } else if (parentObj.label === 'Holder_Name') {
      if (isValid) {
        this.state.holderName = val
      } else {
        this.state.holderName = ''
      }
    } else if (parentObj.label === 'expiryMonth') {
      if (isValid) {
        let currentDate = new Date()
        let month = currentDate.getMonth() + 1
        let year = currentDate.getFullYear()
        let selectedMon = moment()
          .month(val)
          .format('M')
        if (this.state.expiryYear) {
          if (this.state.expiryYear === year && parseInt(selectedMon) < month) {
            this.state.validMonth = true
            let evt = new CustomEvent('month', { detail: { flag: true } })
            window.dispatchEvent(evt)
          } else {
            this.state.validMonth = false
            let evt = new CustomEvent('month', { detail: { flag: false } })
            window.dispatchEvent(evt)
          }
        }
        this.state.expiryMonth = val
      } else {
        this.state.expiryMonth = ''
      }
    } else if (parentObj.label === 'expiryYear') {
      if (isValid) {
        let date = new Date()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        let selectedMon = moment()
          .month(this.state.expiryMonth)
          .format('M')
        if (val === year && parseInt(selectedMon) < month) {
          this.state.validMonth = true
          let evt = new CustomEvent('month', { detail: { flag: true } })
          window.dispatchEvent(evt)
        } else {
          this.state.validMonth = false
          let evt = new CustomEvent('month', { detail: { flag: false } })
          window.dispatchEvent(evt)
        }
        this.state.expiryYear = val
      } else {
        this.state.expiryYear = ''
      }
    } else if (parentObj.label === 'cvv') {
      if (isValid) {
        this.state.cvv = val
      } else {
        this.state.cvv = ''
      }
    } else if (parentObj.label === 'monthlyDebitDay') {
      if (isValid) {
        this.state.monthlyDebitDay = val
      } else {
        this.state.monthlyDebitDay = ''
      }
    } else if (parentObj.label === 'Street') {
      if (isValid) {
        this.state.userAddress.street = val
      } else {
        this.state.userAddress.street = ''
      }
    }
    this.setState(
      {
        refresh: true
      },
      () => this.validateForm()
    )
  }

  validateForm() {
    if (this.state.activeTab === 0) {
      if (
        this.state.bankName !== '' &&
        this.state.accountName !== '' &&
        this.state.accountNumber !== '' &&
        this.state.accountType !== '' &&
        this.state.routingNo !== ''
      ) {
        this.setState(
          {
            disabled: false
          },
          () => console.log('====Button===' + this.state.disabled)
        )
      } else {
        this.setState(
          {
            disabled: true
          },
          () => console.log('====Button===' + this.state.disabled)
        )
      }
    } else if (this.state.activeTab === 1) {
      if (
        this.state.cardNumber !== '' &&
        this.state.holderName !== '' &&
        this.state.expiryMonth !== '' &&
        this.state.expiryYear !== '' &&
        this.state.cvv !== '' &&
        !this.state.validMonth
      ) {
        this.setState({
          disabled2: false
        })
      } else {
        this.setState({
          disabled2: true
        })
      }
    }
  }
  handleChange = (event, newValue) => {
    console.log('====================New Value' + newValue)
    this.setState({
      loaderShow: true,
      refresh: true
    })
    let flag

    if (newValue === 0) {
      this.setState({ activeTab: 0, errCodeACH: this.state.errCodeACH })
    } else {
      this.setState({ activeTab: 1 })
    }
  }

  handleChangeRadio = event => {
    this.setState({ selectedValue: event.target.value })
  }

  getPaymentData = async () => {
    return getRecurringDateData()
      .then(res => {
        if (res && res.data && res.data.response) {
          const paymentDatamodel = res.data.response;
          // Set both paymentData and paymentDatamodel to the API response object
          this.setState(prevState => ({
            paymentData: paymentDatamodel,
            paymentDatamodel,
            selectedBillingDay: prevState.selectedBillingDay === '' && paymentDatamodel.draftDay !== undefined ? paymentDatamodel.draftDay : prevState.selectedBillingDay,
          }), () => console.log("paymentData:", this.state.paymentData, "paymentDatamodel:", this.state.paymentDatamodel));
        }
      })
      .catch()
  }

  getPayType = empid => {
    getPaymentType(empid)
      .then(res => {
        if (res && res.data) {
          this.setState({
            memberDetails: res.data.response,
            paymentType: res.data.response.type
          })
        }
      })
      .catch()
  }

  changePaymentMode = () => {
    this.setState({ loader: true, MsgModalerror: '' })

    let obj
    var payType = ''
    if (this.state.activeTab == 0) {
      payType = 'ACH'
    } else {
      payType = 'CC'
    }

    obj = {
      source: this.state.sourceCode,
      bankName: this.state.bankName,
      accountName: this.state.accountName,
      accountNumber: this.state.accountNumber,
      accountType: this.state.accountType,
      routingNo: this.state.routingNo,

      cardNumber: this.state.cardNumber,
      holderName: this.state.holderName,
      expiryMonth: this.state.expiryMonth
        ? moment()
            .month(this.state.expiryMonth)
            .format('M')
        : '',
      expiryYear: this.state.expiryYear,
      cvv: this.state.cvv,
      paymentType: payType,
      subId: this.state.subId
    }

    storeTransaction(obj).then(res => {
      if (res.data.code == 200) {
        if (this.state.activeTab == 0) {
          this.setState({
            open: false,
            loader: true
          })
        }
        if (this.state.activeTab == 0) {
          this.setState({
            open: false,
            loader: true
          })
        }
        this.setState({ addressModal: true, loader: false })
        // this.setState({ errorModal: true, open: false, loader: false, MsgModal: 'Updated payment details successfully!' }, () => {
        //   this.getSourceCodeFun()
        // })
      } else if (res.data.code == 202) {
        let raw = res?.data?.response || ''
        let errMsg = ''

        try {
          // Handle new 500 format
          if (raw.startsWith('500')) {
            let match = raw.match(/"message"\s*:\s*"([^"]+)"/)
            if (match) {
              errMsg = match[1].split(' REFID')[0].trim()
            }
          }
          // Old logic
          else {
            let x = JSON.parse(raw).error_message || ''
            if (x.includes('-')) {
              let cds = x.split(' - ')
              errMsg = cds[1]
            } else {
              errMsg = x
            }
          }
        } catch (e) {
          errMsg = 'Something went wrong. Please try again.'
        }

        this.setState({ MsgModalerror: errMsg, loader: false, errCodeACH: true })

        if (this.state.activeTab == 0 && errMsg !== '') {
          this.setState({
            errCodeACH: true,
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: '',
            reqFlag: false
          })

          let evt = new CustomEvent('errorCode', { detail: { flag: true } })
          window.dispatchEvent(evt)
        }

        if (this.state.activeTab == 1) {
          this.setState({
            errCodeCC: true,
            bankName: '',
            accountNumber: '',
            accountType: '',
            routingNo: '',
            errCodeACH: false
          })

          let evt = new CustomEvent('errorCode', { detail: { flag: true } })
          window.dispatchEvent(evt)
        }
      } else if (res.data.code == 204) {
        if (this.state.activeTab == 0) {
          this.setState({
            MsgModalerrorFooterACH: 'Source is not registered',
            loader: false,
            MsgModalerrorFooterCC: '',
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: ''
          })
        } else {
          this.setState({
            MsgModalerrorFooterCC: 'Source is not registered',
            loader: false,
            MsgModalerrorFooterACH: '',
            bankName: '',
            accountNumber: '',
            accountType: '',
            routingNo: ''
          })
        }
      } else if (res.data.code == 500) {
        if (this.state.activeTab == 0) {
          this.setState({
            MsgModalerrorFooterACH: 'Internal server error',
            loader: false,
            MsgModalerrorFooterCC: '',
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: ''
          })
        } else {
          this.setState({
            MsgModalerrorFooterCC: 'Internal server error',
            loader: false,
            MsgModalerrorFooterACH: '',
            bankName: '',
            accountNumber: '',
            accountType: '',
            routingNo: ''
          })
        }
      } else {
        let x = JSON.parse(res.data.response).error_message
        let cds = x.split(' - ')
        if (this.state.activeTab == 0) {
          this.setState({
            MsgModalerrorFooterACH: cds[1],
            loader: false,
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: ''
          })
        } else {
          this.setState({ MsgModalerrorFooterCC: cds[1], loader: false, bankName: '', accountNumber: '', accountType: '', routingNo: '' })
        }
      }
    })
  }

  handleCloseErrorModal = () => {
    this.getAccountNumber();
    window.location.reload();
    this.setState({
      errorModal: false,

      bankName: '',
      accountName: this.state.accountName,
      accountNumber: '',
      accountType: '',
      routingNo: '',

      cardNumber: '',
      holderName: this.state.holderName,
      expiryMonth: '',
      expiryYear: '',
      cvv: '',
      payType: '',
      MsgModalerror: '',
      errCodeACH: false,
      errCodeCC: false
    })
  }

  getEnrollMember = memberId => {
    getEnrollMemberInfoById(memberId).then(response => {
      if (response && response.data.response) {
        this.setState({ subID: response.data.response.subId, loader: false }, () => {
          getMemberPlanData(response.data.response.subId).then(res => {
            if (res && res.data.response) {
              this.setState({
                loader: false,
                memberPlanInfo: res.data.response
              })
            } else {
              this.setState({ loader: false })
            }
          })
        })
      } else {
        this.setState({ loader: false })
      }
    })
  }

  getDaysInCurrentMonth = () => {
    // Always return fixed days 0-15, no month logic
    return {
      days: Array.from({ length: 16 }, (_, i) => i),
      monthName: ''
    }
  }

  calculateNextPaymentDate = (draftDay) => {
    const { paymentData } = this.state;
    if (paymentData && paymentData.coverageDate && paymentData.paymentNumber !== undefined && draftDay !== '') {
      // Formula: coverageDate + paymentNumber (days) - draftDay (days)
      const nextDate = moment(paymentData.coverageDate)
        .add(paymentData.paymentNumber, 'days')
        .subtract(draftDay, 'days');
      this.setState({ nextRecurringDate: nextDate.format('MM/DD/YYYY') });
    } else {
      this.setState({ nextRecurringDate: '' });
    }
  }

  handleBillingDayChange = (val, isValid, parentObj) => {
    if (isValid) {
      let nextRecurringDate = '';
      const { paymentDatamodel } = this.state;
      if (
        paymentDatamodel &&
        paymentDatamodel.coverageDate &&
        paymentDatamodel.paymentNumber !== undefined &&
        val !== ''
      ) {
        // Calculate new date
        const nextDate = moment(paymentDatamodel.coverageDate)
        .subtract(val, 'days')
        .add(paymentDatamodel.paymentNumber, 'months')
        nextRecurringDate = nextDate.format('MMM DD, YYYY');
      }
      this.setState({ selectedBillingDay: val, nextRecurringDate });
    } else {
      this.setState({ selectedBillingDay: '', nextRecurringDate: '' });
    }
  }

  openDraftDayModal = () => {
    // Validation: If paidThroughDate < today, show error modal
    console.log('openDraftDayModal paymentData:', this.state.paymentDatamodel);
    const paidThroughDate = this.state.paymentDatamodel?.paidThroughDate;
    const today = moment.utc().startOf('day');
    console.log('paidThroughDate:', paidThroughDate);
    console.log('today:', today.toISOString());
    if (paidThroughDate && moment.utc(paidThroughDate).isBefore(today, 'day')) {
      this.setState({
        errorModal: true,
        MsgModal: `To change your billing date, call Member Services team at : ${localStorage.getItem('CONTACT_NUMBER')} , Monday through
                  Friday 8:00 am to 8:00 pm CST.`
      });
      return;
    }
    // Only allow days 0-15 for draft day selection (fixed, no month logic)
    const daysRange = Array.from({ length: 16 }, (_, i) => i)
    this.setState(prevState => ({
      loaderShow: true,
      open: false,
      effectiveDateModal: false,
      draftDayModal: true,
      currentMonthDays: daysRange,
      currentMonthName: '',
      // Do NOT overwrite selectedBillingDay here, let getPaymentData handle it
    }))

    var tDate = new Date()

    var getFirstPaymentAmount = this.state.paymentData.paymentAmount
    if (getFirstPaymentAmount != undefined) {
      getFirstPaymentAmount = '$' + Number(getFirstPaymentAmount).toFixed(2)
    } else {
      getFirstPaymentAmount = '$0'
    }

    this.setState({
      loaderShow: false,
      firstPaymentAmount: getFirstPaymentAmount,
      todayDate: moment(tDate).format('dddd, MMMM Do, YYYY'),
      initialApplicationFee: '$75'
    })
  }

  answerChangeHandler = (event, name, optionId) => {
    if (name === 'radio') {
      var paymentDate = this.state.beforeEffectiveDateFlag
        ? moment(this.state.beforeEffectiveDate)
            .subtract(event.target.value, 'days')
            .format('MM-DD-YYYY')
        : moment(this.state.memberPlanInfo.targetDate)
            .subtract(event.target.value, 'days')
            .format('MM-DD-YYYY')
      var getSubsequentPaymentDate = this.state.beforeEffectiveDateFlag
        ? moment(this.state.beforeEffectiveDate)
            .subtract(event.target.value, 'days')
            .format('MM-DD-YYYY')
        : moment(this.state.memberPlanInfo.targetDate)
            .subtract(event.target.value, 'days')
            .format('MM-DD-YYYY')

      var varDate = new Date(paymentDate)
      var today = new Date()

      if (varDate >= today) {
        console.log('future date')
      } else {
        console.log('past date')
        paymentDate = today
      }
      this.setState({
        draftDaySelected: event.target.value,
        effectivePaymentDate: moment(this.state.memberPlanInfo.targetDate).format('dddd, MMMM Do, YYYY'),
        firstPaymentDate: moment(paymentDate).format('dddd, MMMM Do, YYYY'),
        subsequentPaymentDate: getSubsequentPaymentDate
      })
    }
  }

  updateDraftDay = () => {
    if (!this.state.selectedBillingDay) {
      this.setState({
        errorModal: true,
        MsgModal: 'Please select a billing day.'
      })
      return
    }
    
    this.setState({ loader: true })
    createCase().then(res => {
      if (res && res?.data?.success) {
        this.setState({
          errorModal: true,
          open: false,
          draftDayModal: false,
          loader: false,
          MsgModal: `Your billing date change request for day ${this.state.selectedBillingDay} has been submitted.`
        })
      } else {
        this.setState({
          errorModal: true,
          open: false,
          loader: false,
          draftDayModal: false,
          MsgModal: `We could not process your request. Please contact our Member Services team at (888) 366-6243 or email customerservice@universalhealthfellowship.org. We are available Monday through Friday from 8:00am to 8:00pm EST.`
        })
      }
    })
  }

  handleCloseDraftDayModal = () => {
    this.setState({
      loaderShow: false,
      open: false,
      draftDayModal: false,
      draftDaySelected: ''
    })
    window.location.reload();
  }

  goBack = () => {
    this.props.history.push('/')
  }

  getRecurringDate = () => {
    if (this.state.paymentData.recurringDate) {
      return `Your next billing date: <b>${moment(this.state.paymentData.recurringDate).format('dddd, MMMM Do, YYYY')}</b>`
    } else {
      return ''
    }
  }
  getRecurringDay = (myDate) => {
    if (this.state.paymentData.recurringDate) {
      let date = new Date()
      let dateDay = date.getDate()
      let dateMonth = date.getMonth()
      let dateYear = date.getFullYear()
      if (parseInt(moment(this.state.paymentData.recurringDate).date()) < dateDay) {
        if (dateMonth === 12) {
          dateYear += 1
          dateMonth = 1
        } else {
          dateMonth += 1
        }
        dateDay = moment(this.state.paymentData.recurringDate).date()
      }
      return `${dateMonth + 1}/${dateDay}/${dateYear}`
    } else {
      return ''
    }
  }

  // Call API to update billing date
  submitBillingDayChange = async () => {
    const apiUrl = process.env.REACT_APP_NEW_BASE_URL_AGENT_DETAIL + 'uhfpaymentService/api/v1/subscriptions/billingDate';
    const payload = {
      source: this.state.sourceCode,
      changeType: 'DRAFT_DAY',
      updateBy: localStorage.getItem('userMail'),
      draftDay: String(this.state.selectedBillingDay),
      changeRequestPortal: 'MemberPortal',
    };
    try {
      const res = await axios.put(apiUrl, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      // Handle new backend response structure
      const { status, message, statusCode } = res.data || {};
      let apiMessage = '';
      if (statusCode === 200) {
        apiMessage = message;
      } else if (statusCode === 202) {
        apiMessage = message ;
      } else if (statusCode === 500) {
        apiMessage = message;
      } else {
        // fallback for any other status
        apiMessage = message;
      }
      this.setState({
        errorModal: true,
        open: false,
        draftDayModal: false,
        loader: false,
        MsgModal: apiMessage,
      });
    } catch (err) {
      // Try to extract message from error response
      let apiMessage = 'Something went wrong, please contact the administrator';
      if (err.response && err.response.data) {
        const { status, message, statusCode } = err.response.data;
        if (message) {
          apiMessage = message;
        } else if (err.response.data.errors && Array.isArray(err.response.data.errors)) {
          apiMessage = err.response.data.errors[0];
        }
      }
      this.setState({
        errorModal: true,
        open: false,
        loader: false,
        draftDayModal: false,
        MsgModal: apiMessage,
      });
    }
  }

  render() {
    const { classes } = this.props

    let currentScreen = ''
    if (this.state.activeTab === 0) {
      currentScreen = (
        <div>
          <Grid container spacing={1} style={{ marginTop: '1%' }}>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} style={{ marginBottom: '-1%' }}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Bank_Name'}
                    reqFlag={true}
                    label={'Bank Name'}
                    value={this.state.bankName}
                    disable={false}
                    style={CustomeCss.textField}
                    length={120}
                    fieldType={'bank_name'}
                    errMsg={'Enter valid bank name'}
                    helperMsg={'Bank name required'}
                    parentDetails={{ label: 'bank_name' }}
                    key={0}
                  ></Sample>
                </Grid>
                <Grid item xs={12} sm={4} style={{ marginBottom: '-1%' }}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Account_Name'}
                    reqFlag={true}
                    label={'Name on Account'}
                    value={this.state.accountName}
                    disable={false}
                    style={CustomeCss.textField}
                    length={120}
                    fieldType={'accountName'}
                    errMsg={'Enter valid account name'}
                    helperMsg={'Name on account required'}
                    parentDetails={{ label: 'Account_Name' }}
                    key={0}
                  ></Sample>
                </Grid>
                <Grid item xs={12} sm={4} style={{ marginBottom: '-1%' }}>
                  <CommonDropDwn
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'AccountType'}
                    label={'Account Type'}
                    value={this.state.accountType}
                    disable={false}
                    style={customStyle.dropDown}
                    fieldType={'dropDwn'}
                    helperMsg={'Select account type'}
                    List={this.state.accountTypes}
                    parentDetails={{ label: 'Account_Type' }}
                  ></CommonDropDwn>
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: '1.5%' }}>
                <Grid item xs={12} sm={6} style={{ marginBottom: '-2%' }}>
                  {this.state.MsgModalerror != '' ? (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Routing_Number'}
                      MsgModalerror={this.state.MsgModalerror}
                      ErrCode={this.state.errCodeACH}
                      reqFlag={true}
                      label={'Routing Number'}
                      value={this.state.routingNo}
                      disable={false}
                      style={CustomeCss.textField}
                      length={9}
                      fieldType={'routingNo'}
                      errMsg={'Enter valid routing number'}
                      helperMsg={this.state.MsgModalerror}
                      parentDetails={{ label: 'Routing_Number' }}
                      key={0}
                    ></Sample>
                  ) : (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Routing_Number'}
                      MsgModalerror={this.state.MsgModalerror}
                      ErrCode={this.state.errCodeACH}
                      reqFlag={true}
                      label={'Routing Number'}
                      value={this.state.routingNo}
                      disable={false}
                      style={CustomeCss.textField}
                      length={9}
                      fieldType={'routingNo'}
                      errMsg={'Enter valid routing number'}
                      helperMsg={'Routing number required'}
                      parentDetails={{ label: 'Routing_Number' }}
                      key={0}
                    ></Sample>
                  )}{' '}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Account_Number'}
                    reqFlag={true}
                    label={'Account Number'}
                    value={this.state.accountNumber}
                    disable={false}
                    style={CustomeCss.textField}
                    length={26}
                    fieldType={'accountNumber'}
                    errMsg={'Account number must be 4 and up to 26 digits'}
                    helperMsg={'Account number required'}
                    parentDetails={{ label: 'Account_Number' }}
                    key={0}
                  ></Sample>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )
    } else if (this.state.activeTab === 1) {
      currentScreen = (
        <div>
          <Grid container spacing={1} style={{ marginTop: '1%' }}>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} style={{ marginBottom: '-3%' }}>
                  {this.state.MsgModalerror != '' ? (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Card_Number'}
                      MsgModalerror={this.state.MsgModalerror}
                      ErrCode={this.state.errCodeCC}
                      reqFlag={this.state.reqFlag}
                      label={'Card Number'}
                      value={this.state.cardNumber}
                      disable={false}
                      style={CustomeCss.textField}
                      length={16}
                      fieldType={'cardNumber'}
                      errMsg={'Card number up to 15 or 16 digits'}
                      helperMsg={this.state.MsgModalerror}
                      parentDetails={{ label: 'Card_Number' }}
                    ></Sample>
                  ) : (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Card_Number'}
                      MsgModalerror={this.state.MsgModalerror}
                      ErrCode={this.state.errCodeCC}
                      reqFlag={this.state.reqFlag}
                      label={'Card Number'}
                      value={this.state.cardNumber}
                      disable={false}
                      style={CustomeCss.textField}
                      length={16}
                      fieldType={'cardNumber'}
                      errMsg={'Card number up to 15 or 16 digits'}
                      helperMsg={'Card number required'}
                      parentDetails={{ label: 'Card_Number' }}
                    ></Sample>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Holder_Name'}
                    reqFlag={true}
                    label={'Card Holder Name'}
                    value={this.state.holderName}
                    disable={false}
                    style={CustomeCss.textField}
                    length={25}
                    fieldType={'holderName'}
                    errMsg={'Enter valid card holder name'}
                    helperMsg={'Card holder name required'}
                    parentDetails={{ label: 'Holder_Name' }}
                  ></Sample>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: '2%' }}>
                <Grid item xs={12} sm={4}>
                  <CommonDropDwn
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'expiryMonth'}
                    label={'Expiration Month'}
                    value={this.state.expiryMonth}
                    disable={false}
                    style={customStyle.dropDown}
                    fieldType={'dropDwn'}
                    helperMsg={'Select expiration month'}
                    errMsg={"The expiration date is before today's date. Enter valid expiration month"}
                    List={this.state.months}
                    parentDetails={{ label: 'expiryMonth', val: this.state.expiryYear }}
                    key={1}
                  ></CommonDropDwn>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <CommonDropDwn
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'expiryYear'}
                    label={'Expiration Year'}
                    value={this.state.expiryYear}
                    disable={false}
                    style={customStyle.dropDown}
                    fieldType={'dropDwn'}
                    helperMsg={'Select expiration year'}
                    errMsg={"The expiration date is before today's date. Enter valid expiration year"}
                    List={this.state.years}
                    parentDetails={{ label: 'expiryYear', val: this.state.expiryMonth }}
                    key={1}
                  ></CommonDropDwn>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'cvv'}
                    label={'CVV'}
                    reqFlag={true}
                    value={this.state.cvv}
                    disable={false}
                    style={CustomeCss.textField}
                    length={4}
                    fieldType={'cvv'}
                    errMsg={'Enter valid CVV'}
                    helperMsg={'CVV required'}
                    parentDetails={{ label: 'cvv' }}
                    key={1}
                  ></Sample>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )
    }
    return (
      <div className="progInfoMainWrapper">
        {this.state.loader ? <CommonLoader /> : null}
        <Header name={'MyTransactions'} />
        <div className="container progInfoContainer" style={{ zIndex: '0' }}>
          <sapn className="Back_page" onClick={this.goBack}>
            <ArrowBackIcon style={{ width: '24px', height: '24px', color: ' #2e3192', marginRight: '5px' }} onClick={this.goBack} />
            BACK
          </sapn>
          <div className="commonWrap" style={{ marginTop: '-27px' }}>
            <div className="progInfoSection" style={{ marginTop: '-15px',backgroundColor:'#f6f9ff' }}>
              <span className="progInfoTitle">MY PAYMENTS</span>
            </div>

            {this.state.paymentData?.monthlyPayment && this.paymentInformationScreen()}

            <div className="tablebackgroundouter">
              {this.state.tableData && this.state.tableData.length > 0 ? (
                <TransactionDataTable tableData={this.state.tableData} />
              ) : (
                <div className="data_not_found">
                  <h5 class="noneeds_msg_display">{this.state.notfoundmsg}</h5>
                </div>
              )}
            </div>

            <div className="progInfoFooter" style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}>
              <div className="row">
                <div className="col-md-6">
                  {/* <button
                    type="button"
                    onClick={this.handleClickOpen}
                    className="blueActionBtn border-0 mr-2 text-uppercase"
                    style={{ marginTop: '10px' }}
                  >
                    Change Payment Method
                  </button>

                  <button
                    type="button"
                    onClick={this.openDraftDayModal}
                    className="blueActionBtn border-0 mr-2 text-uppercase"
                    style={{ marginTop: '10px' }}
                  >
                    Change Billing Date
                  </button> */}
                </div>

                <Tooltip placement="top" arrow title="Chat with a Universal Health Fellowship Representative">
                <CrudButton
                  className={'purechat-button-expand'}
                  color="primary"
                  onClick={() => window.pureChat()}
                  aria-label="add"
                  style={{
                      width: '65px',
                      height: '65px',
                      backgroundColor : "#ed1c24",
                      color: '#ffffff',
                      borderRadius: '50%',
                      border: "none",
                      position: 'fixed',
                      right: '40px',
                      bottom: '40px',
                      zIndex: 109,
                  }}
                >
                    <ForumIcon />
                </CrudButton>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>

        <Modal size="lg" show={this.state.open} onHide={this.handleClose} centered className="ChangPayModal" backdrop="static">
          {localStorage.getItem('SOURCE') === 'NEO' ? (
            <Modal.Body>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <span style={{ textAlign: 'center', fontSize: '16px', fontWeight: '400' }}>
                  To change your payment method, call Member Services team at : {localStorage.getItem('CONTACT_NUMBER')} , Monday through
                  Friday 8:00 am to 8:00 pm CST.
                </span>
              </Grid>
            </Modal.Body>
          ) : (
            <Modal.Body>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <span class="Change-Payment-Method">Change Payment Method</span>
                <IconButton aria-label="close" onClick={this.handleClose} style={{ marginTop: '-13px' }}>
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <p class="The-fellowship-incurs-additional-fees-related-to-p">
                    The fellowship incurs additional fees related to processing credit cards that we do not incur when processing ACH
                    payments. We therefore encourage our members to pay by ACH, yet offer credit card payments as an option as well. If you
                    choose to pay by credit card, you will incur an additional 3.5% fee to cover the fellowship’s cost.
                  </p>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <AntTabs value={this.state.activeTab} onChange={this.handleChange} indicatorColor="primary" textColor="primary">
                    <AntTab
                      label="ACH DEBIT"
                      className="ant-col-15 tabBtn tabFirst"
                      icon={this.state.activeTab == 0 ? <RadioButtonCheckedIcon style={{ marginBottom: 4, marginRight: 5 }} /> : <RadioButtonUncheckedIcon style={{ marginBottom: 4, marginRight: 5 }} />}
                    />
                    <AntTab
                      label="CREDIT CARD"
                      className="ant-col-15 tabBtn tabSecond"
                      icon={this.state.activeTab == 1 ? <RadioButtonCheckedIcon style={{ marginBottom: 4, marginRight: 5 }} /> : <RadioButtonUncheckedIcon style={{ marginBottom: 4, marginRight: 5 }} />}
                    />
                  </AntTabs>
                </Grid>
              </Grid>
              <Grid container direction="row" justify="flex-end" alignItems="flex-end">
                <Grid item xs={12} sm={3} md={4}>
                  <table className="Last_4_digit">
                    <td className="td_style1">Account Number currently on file</td>
                    <td className="td_style" style={{ verticalAlign: 'middle' }}>
                      {/* XXXXXX4567 */}
                      {this.state.accountNo}
                    </td>
                  </table>
                </Grid>
              </Grid>
              {currentScreen}
            </Modal.Body>
          )}

          <Modal.Footer>
            {localStorage.getItem('SOURCE') === 'NEO' ? (
              <Button variant="secondary" onClick={this.handleClose} style={{ marginRight: '15px' }} class="ButtonBG">
                OK
              </Button>
            ) : (
              <>
                {this.state.activeTab === 0 ? (
                  <span className="Footer-error-msg" style={{ width: '500px' }}>
                    {this.state.MsgModalerrorFooterACH}
                  </span>
                ) : (
                  <span className="Footer-error-msg" style={{ width: '500px' }}>
                    {this.state.MsgModalerrorFooterCC}
                  </span>
                )}
                <NextButton
                  variant="contained"
                  color="primary"
                  onClick={this.handleClose} 
                  style={{fontSize:"15px", fontWeight:"600", fontStretch:"normal", fontStyle:"normal", lineHeight:.90, letterSpacing:"1.44px", textAlign:"center", marginRight: '15px'}}
                >
                  CANCEL
                </NextButton>
                {/* onClick={this.changePaymentMode} */}
                <NextButton
                  variant="contained"
                  disabled={this.state.activeTab == 0 ? this.state.disabled : this.state.disabled2}
                  color="primary"
                  onClick={this.changePaymentMode} style={{fontSize:"15px", fontWeight:"600", fontStretch:"normal", fontStyle:"normal", lineHeight:.90, letterSpacing:"1.44px", textAlign:"center"}}
                >
                  DONE
                </NextButton>
              </>
            )}
          </Modal.Footer>
        </Modal>

        {/*------------------Draft day modal-------------------------------------------  */}

        {localStorage.getItem('SOURCE') === 'NEO' ? (
          <Modal size="small" show={this.state.draftDayModal} onHide={this.handleCloseDraftDayModal} centered backdrop={false} keyboard={true} style={{ zIndex: 1050 }}>
            <Modal.Header>
            <Modal.Title style={{
              fontFamily:"Roboto",
              paddingBottom:"-10px",
              fontWeight:"500", 
              fontSize:"18px", 
              fontStretch:"normal", 
              fontStyle:"normal",
              lineHeight:1,
              letterSpacing:"0.15px",
              textAlign:"center",
              color:"#2e3192"}}>
              Billing Details</Modal.Title>
            <IconButton aria-label="close" onClick={this.handleCloseDraftDayModal} style={{ marginTop: '-20px' }}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>
            <Modal.Body>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <span style={{ textAlign: 'center', fontSize: '16px', fontWeight: '400' }}>
                  To change your billing date, call Member Services team at : {localStorage.getItem('CONTACT_NUMBER')} , Monday through
                  Friday 8:00 am to 8:00 pm CST.
                </span>
              </Grid>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseErrorModal} class="ButtonBG">
              OK
            </Button>
          </Modal.Footer>
            </Modal>
          ) : (
        <Modal size="small" show={this.state.draftDayModal} onHide={this.handleCloseDraftDayModal} centered backdrop={false} keyboard={true} style={{ zIndex: 1050 }}>
          <Modal.Header style={{ marginTop: '14px' }}>
            <Modal.Title style={{
              fontFamily:"Roboto",
              marginBottom:"-20px",
              fontWeight:"500", 
              fontSize:"18px", 
              fontStretch:"normal", 
              fontStyle:"normal",
              lineHeight:1,
              letterSpacing:"0.15px",
              textAlign:"center",
              color:"#2e3192"}}>
              Choose When You Want To Be Charged</Modal.Title>
            <IconButton aria-label="close" onClick={this.handleCloseDraftDayModal} style={{ marginTop: '-14px' }}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>

          <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto', paddingBottom: '20px' }}>
            {this.state.loader ? <CommonLoader /> : null}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '0px' }}>
                  To make it easier for you to plan your cash flow, you can decide when your monthly payment is processed.
                  Please select how many days before payment due date, you would like your account to be charged.
                </p>
              </Grid>
              <Grid item xs={8} style={{ position: 'relative', zIndex: 9999 }}>
                <CommonDropDwn
                  setChild={this.handleBillingDayChange.bind(this)}
                  name={'BillingDay'}
                  label={'Select Day'}
                  value={this.state.selectedBillingDay}
                  disable={false}
                  style={{
                    ...customStyle.dropDown,
                    zIndex: 9999,
                    fontSize: '1.2rem',
                    padding: '14px 18px',
                    margin: '8px 0',
                    minHeight: '48px',
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                        width: 100,
                        fontSize: '1.1rem',
                        padding: '10px',
                        margin: '5px',
                        borderRadius: 8,
                      },
                    },
                  }}
                  fieldType={'dropDwn'}
                  helperMsg={'Select billing day'}
                  List={this.state.currentMonthDays}
                  parentDetails={{ label: 'billingDay' }}
                ></CommonDropDwn>
                <div style={{ margin: '16px 0' }}>
                  <div style={{ display: 'flex', alignItems: 'center',}}>
                    <span style={{ fontWeight: 500 }}>Effective Date:</span>
                    <span style={{ background: '#f0f2fa', borderRadius: 6, padding: '4px 12px', fontWeight: 600, fontSize: 16 }}>
                      {this.state.paymentDatamodel && this.state.paymentDatamodel.coverageDate ? moment(this.state.paymentDatamodel.coverageDate).format('MMM DD, YYYY') : 'N/A'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                    <span style={{ fontWeight: 500 }}>Next Payment Date:</span>
                    <span style={{ background: '#f0f2fa',borderRadius: 6, padding: '4px 12px', fontWeight: 600, fontSize: 16 }}>
                      {/* Show the recurringDate from API as default */}
                      {this.state.nextRecurringDate
                        ? this.state.nextRecurringDate
                        : (this.state.paymentDatamodel && this.state.paymentDatamodel.recurringDate
                            ? moment(this.state.paymentDatamodel.recurringDate).format('MMM DD, YYYY')
                            : 'N/A')}
                    </span>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Modal.Body>

            {/* Error message and submit button logic for next payment date check */}
            {this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
              (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? (
                <div style={{ display: 'flex', alignItems: 'center', color: 'red', fontWeight: 500, margin: '-45px 0 0 0', textAlign: 'left', padding: 10 }}>
                  <InfoOutlinedIcon style={{ color: 'red', marginRight: 8, fontSize: 28 }} />
                  <span>Next payment date is earlier than today. Please select a future date.</span>
                </div>
              ) : null}
            <Modal.Footer style={{ justifyContent: 'flex-end', display: 'flex' }}>
              <Button variant="secondary" onClick={this.handleCloseDraftDayModal} class="ButtonBG" style={{ marginRight: '10px' }}>
                CANCEL
              </Button>
              <Button
                variant="primary"
                onClick={this.submitBillingDayChange}
                className={
                  `ButtonBG${
                    this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))
                      ? ' Mui-disabled' : ''
                  }`
                }
                disabled={this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                  (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))}
                style={{
                  opacity: this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? 0.5 : 1,
                  pointerEvents: this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? 'none' : 'auto',
                  backgroundColor: '#2e3192',
                  color: '#fff',
                  borderRadius: '30px',
                  fontWeight: 600,
                  fontSize: '18px',
                  width: '150px',
                  height: '40px',
                  margin: 0,
                  boxShadow: 'none',
                  textTransform: 'uppercase',
                  letterSpacing: '2px',
                  fontFamily: 'Tungsten',
                  display: 'inline-block',
                  ...(this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? {
                      backgroundColor: '#e0e0e0',
                      color: '#bdbdbd',
                      cursor: 'not-allowed',
                    } : {})
                }}
              >
                SUBMIT
              </Button>
            </Modal.Footer>
        </Modal>
          )}
        {/* <Modal
          size="lg"
          show={this.state.draftDayModal}
          onHide={this.handleCloseDraftDayModal}
          centered
          className="ChangPayModal"
          backdrop="static"
        >
          {localStorage.getItem('SOURCE') === 'NEO' ? (
            <Modal.Body>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <span style={{ textAlign: 'center', fontSize: '17px', fontWeight: 'bold' }}>
                  To change your payment method, call Member Services team at : {localStorage.getItem('CONTACT_NUMBER')} , Monday through
                  Friday 8:00 am to 8:00 pm CST.
                </span>
              </Grid>
            </Modal.Body>
          ) : (
            <Modal.Body>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <span class="Change-Payment-Method" style={{ paddingLeft: 5 }}>
                  Choose When You Want to be Charged
                </span>
                <IconButton aria-label="close" onClick={this.handleCloseDraftDayModal} style={{ marginTop: '-13px' }}>
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} style={{ marginBottom: 10 }}>
                  <p
                    class="yournextpayment"
                    style={{ marginLeft: 5, paddingTop: '10px' }}
                    dangerouslySetInnerHTML={{ __html: this.getRecurringDate() }}
                  >
                    {}
                  </p>
                  <p class="The-fellowship-incurs-additional-fees-related-to-p" style={{ marginLeft: '5px' }}>
                    You can submit a request to change your billing date. Our Member Services team will get in touch with you at the
                    earliest and guide you through the process.
                  </p>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginLeft: '-5px' }}>
                <Grid item xs={12} sm={12}>
                </Grid>
              </Grid>

              <div style={{ padding: '15px 0 0 0', marginLeft: '2px', fontFamily: 'Roboto', fontWeight: '400' }}>
                {this.state.draftDaySelected ? (
                  <div>
                    <div className="row effectiveDateSectionWeb">
                      <div className="col-5">Program Effective Date</div>
                      <div className="col-2"></div>
                      <div className="col-5">{this.state.effectivePaymentDate}</div>
                    </div>

                    <div className="paymentDatesWrapper">
                      <div className="row recurringDateSection">
                        <div className="col-5">Recurring Monthly Payment</div>
                        <div className="col-2">
                          {this.state.firstPaymentAmount}
                          {this.state.paymentType == 'Credit Card' ? <span>&#42;</span> : null}
                        </div>
                        <div className="col-5">
                          {this.state.subsequentPaymentDate} <sup>+</sup>
                        </div>
                      </div>
                      You can submit a request to change your billing date. Our Member Services team will get in touch with you at the
                      earliest and guide you through the process.
                    </div>
                  </div>
                ) : null}
              </div>
            </Modal.Body>
          )}

          <Modal.Footer>
            {localStorage.getItem('SOURCE') === 'NEO' ? (
              <Button variant="secondary" onClick={this.handleClose} style={{ marginRight: '15px' }} class="ButtonBG">
                OK
              </Button>
            ) : (
              <>
                <Button variant="secondary" onClick={this.handleCloseDraftDayModal} style={{ marginRight: '15px' }} class="ButtonBG">
                  CANCEL
                </Button>
                <NextButton
                  variant="contained"
                  color="primary"
                  onClick={() => this.updateDraftDay()}
                >
                  PROCEED
                </NextButton>
              </>
            )}
          </Modal.Footer>
        </Modal> */}

        {/* ===============================Error Modal====================================== */}

        <Modal size="small" show={this.state.errorModal} onHide={this.handleCloseErrorModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title
            style={{
              fontFamily:"Roboto",
              paddingBottom:"-10px",
              fontWeight:"500", 
              fontSize:"18px", 
              fontStretch:"normal", 
              fontStyle:"normal",
              lineHeight:1,
              letterSpacing:"0.15px",
              textAlign:"center",
              color:"#2e3192"}}
            >Billing Details</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <b> {this.state.MsgModal}</b>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseErrorModal} class="ButtonBG">
              OK
            </Button>
          </Modal.Footer>
        </Modal>
<div className='webfooterNew'>
        <CommonFooter />
</div>
      </div>
    )
  }
  paymentInformationScreen = () => {
    return  (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', padding: '25px 5px', backgroundColor: '#f6f9ff', marginBottom: '0px',  gap: '30px' }}>
        <div style={{ paddingLeft: '20px' }}>
          <span class="TitleCurrentPaymentMethod">Monthly Payment</span>
          <br />
          <span class="numberPaymentMethod">
            {this.state.loader ? null : this.state.paymentData?.monthlyPayment ? '$' + Number(this.state.paymentData?.monthlyPayment).toFixed(2) : 'N/A'}
          </span>
        </div>
        <div style={{ paddingLeft: '20px' }}>
          <span class="TitleCurrentPaymentMethod">Current Payment Method</span>
          <br />
          <span class="numberPaymentMethod">
            {this.state.paymentType ? this.state.paymentType == 'Credit Card' ? 'Credit Card' : 'ACH' : 'N/A'}
            {this.state.loader ? null : this.state.paymentData?.paymentMethod ? ': ' + this.state.paymentData?.paymentMethod : ''}
          </span>
        </div>
        <div>
          <button type="button" onClick={this.handleClickOpen} className="newblueActionBtn border-0 mr-2 text-uppercase">
            Change Payment Method
          </button>
        </div>
        <div style={{ paddingLeft: '20px' }}>
          <span class="TitleCurrentPaymentMethod">Upcoming Payment Date</span>
          <br />
          <span class="numberPaymentMethod">
            {this.state.loader ? null : this.state.paymentData?.upcomingPaymentDate ? moment(this.state.paymentData?.upcomingPaymentDate).format('MMM DD, YYYY') : 'N/A'}
          </span>
        </div>
        <div>
          <button
            type="button"
            onClick={this.openDraftDayModal}
            className="newblueActionBtn border-0 mr-2 text-uppercase"
          >
            Change Billing Date
          </button>
        </div>

        <Modal
          size="lg"
          show={this.state.addressModal}
          onHide={(event) => this.hideModal(event)}
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header} closeButton>
            <Modal.Title>Billing Address</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: "450px",
              overflowY: "auto",
              textAlign: "justify",
              wordSpacing: "2px",
            }}
          >

            <div>
              <>
                <h6 style={{ paddingTop: "10px" }}>Billing Address: </h6>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  xs={12}
                  md={12}
                  lg={12}
                >
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.zip}
                        name={"Zip"}
                        label={"Zip Code"}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={5}
                        fieldType={"zip"}
                        errMsg={"Enter Valid Zip Code"}
                        helperMsg={"Zip Code Required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-Zip",
                        }}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.street}
                        name={"Street_suite"}
                        label={"Street,Suite"}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={55}
                        fieldType={"street"}
                        errMsg={"Enter valid street"}
                        helperMsg={"Street required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-Street",
                        }}
                      ></Sample>
                    </div>
                    {/* {
                      (this.state.suggestions && this.state.suggestions[0]) ?
                        <div style={customStyle.suggestionDiv}>
                          <div style={customStyle.closeDropDiv}>
                            <text style={customStyle.closeDrop} onClick={() => this.setState({ suggestions: {}, isBillStreetSelected: true })}>X</text>
                          </div>
                          <Suggestions
                            suggestions={this.state.suggestions}
                            selectSuggestion={(v) => this.selectSuggestion(v)}
                          />
                        </div>
                        :
                        !this.state.isMailingStreet && this.state.userBillingAddress?.street && !this.state.isBillStreetSelected &&
                        <div style={customStyle.noEntriesDiv}>
                          <div style={customStyle.closeDropDiv}>
                            <text style={customStyle.closeDrop} onClick={() => this.setState({ suggestions: {}, isBillStreetSelected: true })}>X</text>
                          </div>
                          <text>No entries available. Please fill the address manually.</text>
                        </div>
                    } */}
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.addrs}
                        name={"Street_address"}
                        label={"Street Address 2"}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={55}
                        fieldType={"street"}
                        errMsg={"Enter valid street"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-Address",
                        }}
                      ></Sample>
                    </div>
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  spacing={1}
                  xs={12}
                  md={12}
                  lg={12}
                >
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1CityPayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.city}
                        name={"City"}
                        label={"City"}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={100}
                        fieldType={"city"}
                        errMsg={"Enter valid city"}
                        helperMsg={"City required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-city",
                        }}
                        makeValid={this.state.makeBCityValid}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1StatePayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        name={"State"}
                        label={"State"}
                        value={this.state.userBillingAddress?.state}
                        reqFlag={true}
                        disable={true}
                        style={customStyle.textFieldWrp}
                        length={2}
                        fieldType={"text"}
                        errMsg={"Enter valid state"}
                        helperMsg={"State required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-state",
                        }}
                        makeValid={this.state.makeBStateValid}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1CountryPayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        name={"Country"}
                        label={"Country"}
                        value={this.state.userBillingAddress?.country}
                        reqFlag={true}
                        disable={true}
                        style={customStyle.textFieldWrp}
                        length={2}
                        fieldType={"text"}
                        errMsg={"Enter valid country"}
                        helperMsg={"Country required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-country",
                        }}
                        makeValid={this.state.makeBCountryValid}
                      ></Sample>
                    </div>
                  </Grid>
                </Grid>
              </>
            </div>
          </Modal.Body>
          <Modal.Footer 
          style={{display:"flex-inline",justifyContent:"flex-end",alignItems:"right", gap:"10px"}}>
            <Button
              variant="contained"
              color="primary"
              onClick={(event) => this.hideModal(event)}
              style={customStyle.m10}
            >
              CANCEL
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={this.state.isBillAddrValid}
              onClick={this.submitAddress}
              style={customStyle.m10}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
  openChat = () => {
    sessionStorage.setItem('chatwindow', true)
    this.props.history.push('/')
  }
}
